import axios from 'axios';
import authService from './authService';
import router from '@/router';
import {API_URL} from '@/config/api';

const api = axios.create({
    baseURL: API_URL,
    timeout: 30000,
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
    (config) => {
        const token = authService.token.get();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Só faz logout se a rota atual requer autenticação
            const currentRoute = router.currentRoute;
            const requiresAuth = currentRoute.matched.some(record => record.meta.requiresAuth === true);

            if (requiresAuth) {
                authService.logout();
            }
        }
        return Promise.reject(error);
    }
);

export default {

    //{
    //   "id": 10,
    //   "name": "João",
    //   "willAttend": null,
    //   "companions": [
    //     { "id": 1, "name": "Maria", "willAttend": null },
    //     { "id": 2, "name": "Pedro", "willAttend": null }
    //   ]
    // }
    findByCode(code) {
        return api.get(`/wedding-guests/code/${code}`);
    },

    findByName(name) {
        return api.post(`/wedding-guests/find`, {name});
    },

    // POST /api/wedding-guests/confirm
    // json
    // Copy code
    // {
    //   "guestId": 10,
    //   "willAttend": true,
    //   "companions": [
    //     { "id": 1, "willAttend": false },
    //     { "id": 2, "willAttend": true }
    //   ]
    // }
    confirm(data) {
        return api.post(`/wedding-guests/confirm`, data);
    },

    // [
    //     {
    //         "id": 2,
    //         "name": "Bruno Lutterbach",
    //         "willAttend": true,
    //         "companions": [
    //             {
    //                 "id": 53,
    //                 "name": "Pedro",
    //                 "willAttend": true
    //             },
    //             {
    //                 "id": 52,
    //                 "name": "Larissa",
    //                 "willAttend": false
    //             }
    //         ]
    //     },
    //     {
    //         "id": 52,
    //         "name": "Lauana",
    //         "willAttend": true,
    //         "companions": []
    //     }
    // ]
    listAll() {
        return api.get(`/wedding-guests`);
    },

    //{
    //     "totalGuests": 2,
    //     "confirmedGuests": 2,
    //     "declinedGuests": 0,
    //     "pendingGuests": 0,
    //     "totalCompanions": 2,
    //     "confirmedCompanions": 1,
    //     "declinedCompanions": 1,
    //     "pendingCompanions": 0,
    //     "totalPeople": 4,
    //     "totalConfirmed": 3
    // }
    reportAttendance() {
        return api.get(`/wedding-guests/report`);
    },

// {
//     "name": "Bruno Lutterbach",
//     "companions": [
//     "Larissa",
//     "Pedro"
// ]
// }
    create(data) {
        return api.post(`/wedding-guests`, data);
    },

    // PUT /api/wedding-guests/{id}
    // O código do convite não muda. Acompanhante com id é renomeado (mantendo a
    // resposta de presença); sem id é novo; o que sumir da lista é removido.
    // {
    //     "name": "Bruno Lutterbach",
    //     "companions": [
    //         { "id": 52, "name": "Larissa" },
    //         { "name": "Pedro" }
    //     ]
    // }
    update(id, data) {
        return api.put(`/wedding-guests/${id}`, data);
    },

    delete(id) {
        return api.delete(`/wedding-guests/${id}`);
    }
}